webpackJsonp([165497393597108],{

/***/ 1594:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/hannah-bennett/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-hannah-bennett-dee835eb55bfd91eecae.js